import React from 'react';
import api from '../apiConnector'
import FrontRecapitulatif from './recapitulatif';
import FrontProgress from './progress';
import fleche_retour from '../img/flèche CTA retour.svg'
import fleche_avant from '../img/flèche CTA avant.png'

export default class FormPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showValidate:false,
        }
        this.submitting = false
        this.hasNext = true
        this.hasRecap = true
        this.refRecap = React.createRef()
    }

    goToRecap() {
        this.refRecap.current?.scrollIntoView({behavior:'smooth'})
    }

    onSubmit() {
        if ( this.validate() ) {
            this.next()
        } else {
            this.setState({showValidate:true})
            this.focusRef.current?.scrollIntoView({behavior:'smooth',block:'center'});
            this.submitting = true
            this.forceUpdate()
        }
    }


    validateField(field) {
        return ! this.props.devis.validateMessage( field )
    }

    validate( fields, parentValue=true ) {
        return ! this.focusRef
    }

    componentDidUpdate() {
        if ( this.focusRef && this.submitting ) {
            this.focusRef.current.scrollIntoView({behavior:'smooth',block:'center'});
        }
        this.submitting = false
    }

    focusError( e ) {
        if ( !this.focusRef ) this.focusRef = e
    }

    render() {
        this.focusRef = undefined
        const container = {
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            showValidate:this.state.showValidate,
            focusError: this.focusError.bind(this),
            setPage: this.props.setPage,
            subscribeSolly: this.props.subscribeSolly
        }
        const content = this.doRender(container)
        return <>
        <FrontProgress lastBranch={this.props.lastBranch || this.props.devis.tb} onSubmit={this.onSubmit.bind(this)} comparateursCompleted={this.props.devis.params.comparateursCompleted} setPage={this.props.setPage} page={this.props.page} topRef={this.props.topRef}/>
        <div className={this.hasRecap ? 'container' : 'container narrow'}>
            <div className="contentbox front_form">
                {content}
            </div>

            <div className="contentbox_middle"/>

            {this.hasRecap ? 
            <div className="contentbox contentbox_right">
                <FrontRecapitulatif selfRef={this.refRecap} api={api} devis={this.props.devis} container={container} contactBoxOnTop={this.contactBoxOnTop}/>
            </div>:<></>}
        </div>
        <div className="footerbuttons">
            <div className="footer_row">
                <button className="invert" onClick={this.back.bind(this)}><img src={fleche_retour}/> Retour</button>
                <div className="spacer"/>
                {this.hasNext ? <button onClick={this.onSubmit.bind(this)}>{this.nextTitle || 'Suivant'}<img src={fleche_avant}/></button> : <></> }
            </div>
        </div>

 

        </>
    }
}